// Libs
import classNames from 'classnames/bind';
// Components, Layouts, Pages
import { HomeTemplate } from '~/pages/student';
// Others
// Styles, images, icons
import styles from './Dashboard.module.scss';

const cx = classNames.bind(styles);

const Dashboard = () => {
  return <HomeTemplate />;
};

export default Dashboard;
